import React, { useState } from 'react';

import { StructuredTaskPanel } from '@/common/components/StructuredTaskDetails';
import { TaskHeader } from '@/common/components/TaskHeader';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Typography } from '@mui/material';

import { Loading } from '../../common/components/Loading';
import { Resource } from '../../common/constants/resource';
import { MIBResponses } from '../detail/tasks/mib/MIBResponses';
import { factsExist } from '../detail/utilities/taskDetailUtilities';
import { Evidence } from '../tasks/types/evidence';
import { MIB } from '../tasks/types/mib';
import { TaskTypes } from '../tasks/types/taskTypes';
import { fetchEvidenceData } from './helpers';

export const MIBDetail = ({
  product,
  carrier,
  policyId,
  evidenceId,
}: {
  product: string;
  carrier: string;
  policyId: string;
  evidenceId: number;
}) => {
  const [expanded, setExpanded] = useState(false);
  const [evidence, setEvidence] = useState<Evidence | null>(null);
  const [evidenceInprogress, setEvidenceInprogress] = useState(false);
  const [evidenceReady, setEvidenceReady] = useState(false);
  const doExpand = () => {
    (async () => {
      if (!expanded) {
        if (!evidenceReady && !evidenceInprogress) {
          // fetch ruleResultData
          setEvidenceInprogress(true);
          const result = await fetchEvidenceData(
            product,
            carrier,
            policyId,
            evidenceId.toString(),
            TaskTypes.MIB,
          );
          setEvidence(result);
          setEvidenceReady(true);
          setEvidenceInprogress(false);
        }
      }
      setExpanded(!expanded);
    })();
  };

  function renderTaskDetails() {
    const mib: MIB | null = evidence ? (evidence.facts as MIB) : null;

    return (
      <>
        {mib && !mib.recordExists && !evidence?.errorMessage && (
          <p>{Resource.MIB_NO_RECORD}</p>
        )}
        {mib && mib.recordExists && (
          <StructuredTaskPanel>
            <TaskHeader title={Resource.TASK_TITLE_MIB} />
            <MIBResponses sections={mib.sections} />
          </StructuredTaskPanel>
        )}
      </>
    );
  }

  return (
    <Box pt={8}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        ml={-1}
      >
        <Box display="flex" flexDirection="row">
          <Box mt={-0.15} ml={-3.5} position="absolute">
            <IconButton
              style={{ width: '24px' }}
              size="small"
              onClick={doExpand}
            >
              <FontAwesomeIcon
                icon={faAngleRight}
                rotation={expanded ? 90 : undefined}
              />
            </IconButton>
          </Box>
          <Typography variant="h2">MIB</Typography>
        </Box>
      </Box>

      {expanded &&
        (evidenceInprogress ? (
          <Loading fullscreen={false} />
        ) : (
          evidenceReady &&
          (evidence ? (
            factsExist(evidence) ? (
              renderTaskDetails()
            ) : (
              <></>
            )
          ) : (
            <Box>
              <Typography variant="body1">failed to load mib data</Typography>
            </Box>
          ))
        ))}
    </Box>
  );
};
